































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* component */
import Loading from '@/app/components/Common/Loading.vue'
import FieldListItem from '@/app/components/Field/FieldListItem.vue'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'

@Component({
  components: {
    Loading,
    FieldListItem
  }
})
export default class FieldList extends Vue {
  private fieldId: string = ''
  private displayFieldData: Array<{[key:string]: string}> = []
  private detailsData: any[] = []
  private showLoading: boolean = true

  @Prop() private fieldList!: Array<{[key:string]: string}>
  @Prop() private id!: number|string
  @Prop() private target!: string
  @Prop() private flag!: boolean
  @Prop() private displayFlag!: boolean
  @Prop() private accordionChangeFlag!: boolean

  @Watch('$store.state.fieldState.fieldData')
  private onDataChange (newValue: any) {
    this.displayFieldData = []
    this.changeData(newValue)
  }
  @Watch('fieldList')
  private propsData (newValue: any) {
    this.searchAccordionList()
  }

  created () {
    this.searchAccordionList()
  }

  private searchAccordionList () {
    let dataList: any[] = []
    let key: string

    if (this.target === '1') {
      key = 'accordionDistrictId'
    } else if (this.target === '2') {
      key = 'accordionVarietyId'
    } else {
      key = 'accordionUserId'
    }

    this.displayFieldData = this.fieldList
  }

  mounted () {
    let choiceId = this.$route.hash.slice(1)

    if (Session.getChoiceFieldId()! !== null && this.flag) {
      /* ひとつ前に選択していた圃場を開く */
      let fieldId = Session.getChoiceFieldId()
      this.$store.commit('fieldChoiceState/setChoosingFieldId', fieldId)
      let el: any = document.getElementById(String(fieldId))
      if (el !== null) {
        let accordionId = el.parentElement.parentElement.parentElement.previousElementSibling.getAttribute('id')
        let index = accordionId.indexOf('/')
        let id = accordionId.slice(index + 1)
        this.$emit('openSpecificAccordion', id)
      }
    }

    let settingData = JSON.parse(Local.getGraphSettingData(this.$route.params.field_id)!)
    if (this.$route.name === '圃場詳細' && settingData !== null) {
      if (settingData.tab === '3') {
        let el: any = document.getElementById(String(settingData.fieldId))
        if (el !== null) {
          let accordionId = el.parentElement.parentElement.parentElement.previousElementSibling.getAttribute('id')
          let index = accordionId.indexOf('/')
          let id = accordionId.slice(index + 1)
          this.$emit('openSpecificAccordion', id)
        }
      }
    }
  }

  private changeData (val: any) {
    let id:number|string = this.id
    this.displayFieldData = val.filter(function (data: any) {
      return (data.area_id === id)
    })
  }

  public toggleLoading () {
    this.showLoading = false
  }
}
